import { render, staticRenderFns } from "./theme-3.vue?vue&type=template&id=2f04ab09"
import script from "./theme-3.vue?vue&type=script&lang=js"
export * from "./theme-3.vue?vue&type=script&lang=js"
import style0 from "./theme-3.vue?vue&type=style&index=0&id=2f04ab09&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsDownloadBanner: require('/app/components/Commons/DownloadBanner.vue').default,CommonsMaintenance: require('/app/components/Commons/Maintenance.vue').default,CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default,Theme3ConfirmDepositDialog: require('/app/components/Theme3/ConfirmDepositDialog.vue').default,Theme3WithdrawalConfirmDeclineDialog: require('/app/components/Theme3/WithdrawalConfirmDeclineDialog.vue').default,Theme3MenuBar: require('/app/components/Theme3/MenuBar.vue').default,Theme3ImageBackground: require('/app/components/Theme3/ImageBackground.vue').default,Theme3MobileFooter: require('/app/components/Theme3/Mobile/Footer.vue').default,Theme3DesktopFooter: require('/app/components/Theme3/Desktop/Footer.vue').default,Theme3HoldBalanceDialog: require('/app/components/Theme3/HoldBalanceDialog.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default,CommonsLiveChat: require('/app/components/Commons/LiveChat.vue').default})
